module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "doc-component",
    attrs: {
      "id": "grid"
    }
  }, [_c('h1', [_vm._v("Grid")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-12")])]), _vm._v(" "), _c('div', {
    staticClass: "col-1 md-col-2 sm-col-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-1 md-col-2 sm-col-3")])]), _vm._v(" "), _c('div', {
    staticClass: "col-1 md-col-2 sm-col-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-1 md-col-2 sm-col-3")])]), _vm._v(" "), _c('div', {
    staticClass: "col-1 md-col-2 sm-col-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-1 md-col-2 sm-col-3")])]), _vm._v(" "), _c('div', {
    staticClass: "col-1 md-col-2 sm-col-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-1 md-col-2 sm-col-3")])]), _vm._v(" "), _c('div', {
    staticClass: "col-1 md-col-2 sm-col-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-1 md-col-2 sm-col-3")])]), _vm._v(" "), _c('div', {
    staticClass: "col-1 md-col-2 sm-col-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-1 md-col-2 sm-col-3")])]), _vm._v(" "), _c('div', {
    staticClass: "col-1 md-col-2 sm-col-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-1 md-col-2 sm-col-3")])]), _vm._v(" "), _c('div', {
    staticClass: "col-1 md-col-2 sm-col-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-1 md-col-2 sm-col-3")])]), _vm._v(" "), _c('div', {
    staticClass: "col-1 md-col-2 sm-col-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-1 md-col-2 sm-col-3")])]), _vm._v(" "), _c('div', {
    staticClass: "col-1 md-col-2 sm-col-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-1 md-col-2 sm-col-3")])]), _vm._v(" "), _c('div', {
    staticClass: "col-1 md-col-2 sm-col-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-1 md-col-2 sm-col-3")])]), _vm._v(" "), _c('div', {
    staticClass: "col-1 md-col-2 sm-col-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-1 md-col-2 sm-col-3")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-11 sm-col-8 md-col-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-11 sm-col-8 md-col-6")])]), _vm._v(" "), _c('div', {
    staticClass: "col-1 sm-col-4 md-col-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-1 sm-col-4 md-col-6")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-8")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-4")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-6")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-6")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-3")])]), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-9")])])]), _vm._v(" "), _c('h5', [_vm._v("Grid somente com classe mobile")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-11 sm-col-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-11 sm-col-6")])]), _vm._v(" "), _c('div', {
    staticClass: "col-1 sm-col-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-1 sm-col-6")])])]), _vm._v(" "), _c('h5', [_vm._v("Invert")]), _vm._v(" "), _c('div', {
    staticClass: "row-invert"
  }, [_c('div', {
    staticClass: "col-5 sm-col-5 md-col-5"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("1")])]), _vm._v(" "), _c('div', {
    staticClass: "col-1 sm-col-1 md-col-1"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("2")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4 sm-col-4 md-col-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("3")])]), _vm._v(" "), _c('div', {
    staticClass: "col-2 sm-col-2 md-col-2"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("4")])])]), _vm._v(" "), _c('h5', [_vm._v("Invert sem classes mobile")]), _vm._v(" "), _c('div', {
    staticClass: "row-invert"
  }, [_c('div', {
    staticClass: "col-5 md-col-5"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("1")])]), _vm._v(" "), _c('div', {
    staticClass: "col-1 md-col-1"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("2")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4 md-col-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("3")])]), _vm._v(" "), _c('div', {
    staticClass: "col-2 md-col-2"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("4")])])]), _vm._v(" "), _c('h5', [_vm._v("Zerando os gutters")]), _vm._v(" "), _c('div', {
    staticClass: "row no-gutter"
  }, [_c('div', {
    staticClass: "col-6 sm-col-4 md-col-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-6 sm-col-4 md-col-3")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4 sm-col-4 md-col-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-4 sm-col-4 md-col-6")])]), _vm._v(" "), _c('div', {
    staticClass: "col-2 sm-col-4 md-col-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-2 sm-col-4 md-col-3")])])]), _vm._v(" "), _c('h5', [_vm._v("Sem gutters, sem setar classe de mobile")]), _vm._v(" "), _c('div', {
    staticClass: "row no-gutter"
  }, [_c('div', {
    staticClass: "col-6 md-col-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-6 md-col-3")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4 md-col-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-4 md-col-6")])]), _vm._v(" "), _c('div', {
    staticClass: "col-2 md-col-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-2 md-col-3")])])]), _vm._v(" "), _c('h5', [_vm._v("Com margem lateral ")]), _vm._v(" "), _c('div', {
    staticClass: "row row-space"
  }, [_c('div', {
    staticClass: "col-6 sm-col-4 md-col-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-6 sm-col-4 md-col-3")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4 sm-col-4 md-col-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-4 sm-col-4 md-col-6")])]), _vm._v(" "), _c('div', {
    staticClass: "col-2 sm-col-4 md-col-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-2 sm-col-4 md-col-3")])])]), _vm._v(" "), _c('h5', [_vm._v("Com margem e sem gutter")]), _vm._v(" "), _c('div', {
    staticClass: "row no-gutter row-space"
  }, [_c('div', {
    staticClass: "col-6 sm-col-4 md-col-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-6 sm-col-4 md-col-3")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4 sm-col-4 md-col-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-4 sm-col-4 md-col-6")])]), _vm._v(" "), _c('div', {
    staticClass: "col-2 sm-col-4 md-col-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-2 sm-col-4 md-col-3")])])]), _vm._v(" "), _c('h5', [_vm._v("offset-10 (falta o responsivo e definir nomenclatura correta)")]), _vm._v(" "), _c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticClass: "_offset-10 col-2 sm-col-12 md-col-7"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._v("col-1")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-219c500a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Grid.vue
// module id = 131
// module chunks = 1